import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieService } from 'ngx-cookie-service';

import { MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CalendarModule } from 'primeng/calendar';
import { ChipsModule } from 'primeng/chips';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { PanelModule } from 'primeng/panel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { httpInterceptorProviders } from './core/providers/interceptors';
import { msalProviders } from "./core/providers/msal";
import { environment as env } from "./core/environments/environment";
import {
	MsalGuardConfiguration,
	MsalInterceptorConfiguration,
	MsalModule,
	MsalRedirectComponent,
} from "@azure/msal-angular";
import {
	IPublicClientApplication,
	PublicClientApplication,
	InteractionType,
	BrowserCacheLocation,
	LogLevel,
} from '@azure/msal-browser';

export function loggerCallback(logLevel: LogLevel, _message: string) {
	if (!env.production) {
		console.log('MSAL log event occurred.');
	}
}

export function MSALInstanceFactory(): IPublicClientApplication {
	return new PublicClientApplication(
		{
		auth: {
			clientId: env.msalConfig.auth.clientId,
			authority: env.msalConfig.auth.authority,
			redirectUri: env.msalConfig.redirectUri,
			postLogoutRedirectUri: env.msalConfig.postLogoutRedirectUri,
		},
		cache: {
			cacheLocation: BrowserCacheLocation.SessionStorage,
		},
		system: {
			allowPlatformBroker: false, // Disables WAM Broker
		},
	},

		);
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
	const protectedResourceMap = new Map<string, Array<string>>();
	const normalizedVectorBffUri = env.vectorBffConfig.uri.replace(/\/+$/, '');
	protectedResourceMap.set(
		normalizedVectorBffUri,
		env.vectorBffConfig.scopes
	);
	protectedResourceMap.set(
		`${normalizedVectorBffUri}/`,
		env.vectorBffConfig.scopes
	);

	return {
		interactionType: InteractionType.Redirect,
		protectedResourceMap,
	};
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
	return {
		interactionType: InteractionType.Redirect,
		authRequest: {
			scopes: [...env.vectorBffConfig.scopes],
		},
		loginFailedRoute: '/denied',
	};
}

@NgModule({
	declarations: [
		AppComponent,
		LoaderComponent
	],
	imports: [
		FormsModule,
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		TranslateModule.forRoot(),
		CalendarModule,
		DialogModule,
		DropdownModule,
		MenubarModule,
		MessageModule,
		PanelModule,
		SelectButtonModule,
		SidebarModule,
		SplitButtonModule,
		InputMaskModule,
		ChipsModule,
		InputTextModule,
		BreadcrumbModule,
		PanelModule,
		ToolbarModule,
		ToastModule,
		ProgressSpinnerModule,
		MsalModule
	],
	providers: [
		provideHttpClient(withInterceptorsFromDi()),
		provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
		httpInterceptorProviders,
		msalProviders,
		CookieService,
		MessageService
	],
	bootstrap: [
		AppComponent,
		MsalRedirectComponent
	]
})

export class AppModule {}
